import React from 'react';
import { Box, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { SpottingMode, SPOTTING_MODE_LABELS } from '../../types/spotting';

const MODE_HINTS: Record<SpottingMode, string> = {
  off: 'No ember spotting — the fire only spreads along its front.',
  short_range: 'Ember spotting with distances reduced 10x — embers only jump nearby.',
  realistic: 'Full physical ember spotting distances.',
};

interface SpottingModeSelectorProps {
  value: SpottingMode;
  onChange: (mode: SpottingMode) => void;
  /** Compact variant for tight row layouts: smaller buttons, no hint line. */
  dense?: boolean;
}

/** Firebrand spotting selector shared by the weather-modal run views. */
const SpottingModeSelector: React.FC<SpottingModeSelectorProps> = ({ value, onChange, dense = false }) => (
  <Box>
    <Typography
      variant="caption"
      sx={{ color: 'rgba(255, 255, 255, 0.6)', textTransform: 'uppercase', fontSize: '0.75rem', display: 'block', mb: 1 }}
    >
      Spotting
    </Typography>
    <ToggleButtonGroup
      exclusive
      size="small"
      fullWidth={!dense}
      value={value}
      onChange={(_, v) => {
        if (v !== null) onChange(v as SpottingMode);
      }}
      sx={{
        '& .MuiToggleButton-root': {
          color: 'rgba(255, 255, 255, 0.7)',
          borderColor: 'rgba(255, 255, 255, 0.15)',
          textTransform: 'none',
          py: dense ? 0.5 : 1,
          px: dense ? 1.5 : undefined,
        },
        '& .Mui-selected': {
          bgcolor: 'rgba(255, 107, 53, 0.15) !important',
          color: '#fff !important',
          borderColor: '#ff6b35 !important',
        },
      }}
    >
      {(['off', 'short_range', 'realistic'] as SpottingMode[]).map((m) => (
        <ToggleButton key={m} value={m}>
          {SPOTTING_MODE_LABELS[m]}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
    {!dense && (
      <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.5)', display: 'block', mt: 0.5 }}>
        {MODE_HINTS[value]}
      </Typography>
    )}
  </Box>
);

export default SpottingModeSelector;
